import { render, staticRenderFns } from "./RevenueCard.vue?vue&type=template&id=db123be8"
import script from "./RevenueCard.vue?vue&type=script&lang=js"
export * from "./RevenueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports